import React from 'react';
import { TTAContent } from '~/types/tta';

interface ContentInfoProps {
  selectedContent?: TTAContent;
}

export const ContentInfo: React.FC<ContentInfoProps> = ({
  selectedContent,
}) => {
  return (
    <div className="flex flex-col gap-2">
      <h3 className="font-normal text-12 font-500 leading-3 text-neutral-300">
        MENTIONED IN THIS POST
      </h3>
      <p className="truncate text-14 font-400 italic leading-[19.3px] text-neutral-400">
        ...{selectedContent?.relevant_snippet}...
      </p>
    </div>
  );
};
